module.exports = __webpack_public_path__ + "img/logo.fa45a2ec.png";